export const QUESTION_SHOW = "QUESTION_SHOW";
export const QUESTION_HIDE = "QUESTION_HIDE";
export const QUESTION_ANSWER = "QUESTION_ANSWER";
export const RELOAD_LIST = "RELOAD_LIST";
export const START_ANSWER_LOADING = "START_ANSWER_LOADING"
export const STOP_ANSWER_LOADING = "STOP_ANSWER_LOADING"
